<template>
  <div class="view">
    <decorate></decorate>
    <div class="main location_page">
      <div class="nav">
        <div class="left">
          <router-link
            class="front icon_back"
            :to="{ path: '/selfInfo', query: queryData }"
          ></router-link>
        </div>
        添加收货地址
      </div>
      <van-field
        autosize
        clearable
        label="用户名："
        placeholder="请输入用户名"
        v-model="username"
      />
      <van-field
        autosize
        clearable
        type="tel"
        label="手机号码："
        placeholder="+86"
        v-model="telephone"
      />
      <van-field
        autosize
        clearable
        readonly
        right-icon="arrow"
        label="所在地区："
        placeholder
        v-model="area"
        @click="onSelAddr()"
      />
      <van-field
        class="align_top"
        autosize
        clearable
        type="textarea"
        label="详细地址："
        placeholder="如道路、门牌号、小区、楼栋号、单元室等"
        v-model="address"
        maxlength="70"
      />
      <van-field
        autosize
        clearable
        label="邮政编码："
        placeholder="请输入邮政编码"
        v-model="mail"
      />
      <van-popup v-model="showLocat" position="bottom" get-container="body">
        <van-area
          :area-list="areaList"
          :columns-num="2"
          @confirm="setArea"
          @cancel="onAddrCancel"
        />
      </van-popup>
      <div class="submit" @click="getAddress()">提交</div>
      <p class="announce">本活动最终解释权归茄子视频所有</p>
    </div>
  </div>
</template>
<script>
// import sa from "sa-sdk-javascript";
import Vue from "vue";
import { Field, Area, Popup, Icon, Toast } from "vant";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import areaJson from "../plugin/arealist";
import decorate from "./element/decorate";
import "../css/aside.scss";
Vue.use(Field).use(Area).use(Popup).use(Icon);
export default {
  components: { decorate },
  data: function () {
    return {
      areaList: areaJson,
      showLocat: false,
      username: "",
      telephone: "",
      area: "",
      address: "",
      mail: "",
      province: "",
      city: "",
      topHeight: 0,
      stats: 0,
      bcount: 1,
      InfoaddressList: {},
    };
  },
  computed: {
    ...mapState(["homePage"]),
    ...mapState("homePage", ["Syssetting"]),
  },
  watch: {
    //'$route': 'setNewsList'
  },
  created() {
    this.queryData = this.$route.query || {};
    this.topHeight = this.queryData.TopHeight;
    this.stats = this.$route.params.status;
    this.bcount = this.$route.params.acount;
    console.log(this.stats )
    console.log(this.bcount )
  },
  methods: {
    ...mapActions(["fetchHome"]),
    ...mapMutations("homePage", ["setSyssetting"]),
    ...mapMutations([]),
    onSelAddr() {
      this.showLocat = true;
    },
    setArea(val) {
      this.area = val[0].name + val[1].name;
      this.province = val[0].name;
      this.city = val[1].name;
      this.mail = val[val.length - 1].code;
      this.showLocat = false;
    },
    onAddrCancel() {
      this.showLocat = false;
    },
    getAddress() {
      // console.log(`${this.queryData.apptype}_${this.queryData.uid}`)
      // let formName =
      if (this.username == "") {
        Toast({
          message: "请输入用户名",
        });
        return false;
      }
      if (this.telephone == "") {
        Toast({
          message: "请输入手机号",
        });
        return false;
      }
      let phone = /^1[3456789]\d{9}$/;
      if (!phone.test(this.telephone)) {
        Toast({
          message: "请输入正确手机号",
        });
        return false;
      }
      if (this.area == "") {
        Toast({
          message: "请输入所在地区",
        });
        return false;
      }
      if (this.address == "") {
        Toast({
          message: "请输入详细地址",
        });
        return false;
      }
      if (this.mail == "") {
        Toast({
          message: "请输入邮政编码",
        });
        return false;
      }
      let obj = {
        uid: this.queryData.uid,
        userId: this.queryData.userId,
        name: this.username,
        phone: this.telephone,
        address: this.address,
        postcode: this.mail,
        province: this.province,
        city: this.city,
      };
      // console.log(obj)
      this.$store.dispatch("homePage/fetchAddAddress", obj).then((res) => {
        //   console.log(res.code)
        if (res.code == 200) {
          this.$dialog({
            title: "提醒",
            message: "添加地址成功",
          }).then(() => {
            this.sensors.track(
              "BindAddress",
              {
                $element_content: `添加地址成功`,
                app_number: this.queryData.apptype,
              },
              () => {
                //  console.log(1);
              }
            );
            if (this.stats == 2) {
              let obj = {
                userId: this.queryData.userId,
                appId: this.queryData.appId,
                uid: this.queryData.uid,
              };
              this.$store
                .dispatch("homePage/fetchAddressList", obj)
                .then((res) => {
                  // console.log(1)
                  this.InfoaddressList = res.data;
                  // console.log(this.InfoaddressList[0])
                this.$router.push({
                path: "/determineorder",
                name: "determineorder",
                query: this.queryData,
                params: {
                  aidlist: this.InfoaddressList[0],
                  allcount: this.bcount,
                },
              });
                });
              // this.$router.go(-1)
            }
            // else{
            // // console.log(this.stats)
            // // if (this.stats == 0) {
            //   // console.log(this.stats)
            //   this.$router.push({
            //     path: "/selfInfo",
            //     // name: "selfInfo",
            //     query: this.queryData,
            //     // params: { statusTab: 1 },
            //   });
            // // }
            // }
            if(this.stats == 1){
              this.$router.push({
                path: "/selfInfo",
                name: "selfInfo",
                query: this.queryData,
                params: { 
                  status : 1 ,
                  acount: this.bcount,
                },
              });
            }
            if(this.stats == undefined){
              this.$router.push({
                path: "/selfInfo",
                // name: "selfInfo",
                query: this.queryData,
                // params: { statusTab: 1 },
              });
            }
          });
        } else {
          this.$dialog({
            title: "提醒",
            message: "添加地址失败",
          });
        }
      });
    },
  },
  mounted() {
    // const self=this;
    // this.$refs.view.scroll.on('scroll',(position)=>{
    //     self.$parent.scrollY=position.y;
    // })
  },
};
</script>
